import { motion } from "framer-motion"
import React from "react"
import * as styles from "./FormHeader.module.scss"
import { formStageOptions } from "@data/static"
import SiteWrapper from "@components/structure/SiteWrapper/SiteWrapper"
import blueDots from "@images/icons/blueDots.svg"
import tickPink from "@images/icons/tickPink.svg"

const FormHeader = ({ title, step, highestStep, updateStep, supplierDashboard }) => {
  const highestStepPos = highestStep ? formStageOptions.indexOf(highestStep) : 0
  const stepPos = step ? formStageOptions.indexOf(step) : 0
  return (
    <motion.div className={styles.FormHeader} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}>
      {title ? (
        <div className={styles.titleBar}>
          <SiteWrapper className={styles.wrapper}>
            <h1>{title}</h1>
          </SiteWrapper>
        </div>
      ) : null}

      <div className={styles.preForm}>
        <SiteWrapper className={styles.wrapper}>
          <div className={styles.intro}>
            <h3>{supplierDashboard ? "Edit Details" : "Progress"}</h3>
            {highestStepPos > 0 && highestStepPos < formStageOptions.length && (
              <p>Navigate to a previous section if you would like to edit your details</p>
            )}
          </div>
        </SiteWrapper>
        <SiteWrapper className={`${styles.wrapper} ${styles.progressWrapper}`}>
          <div className={styles.progress}>
            {formStageOptions.map((title, index) => {
              const pos = index
              const isComplete = stepPos === formStageOptions.length - 1
              const isAvailable = pos <= highestStepPos && pos != stepPos && !isComplete
              const hideReview = supplierDashboard && index >= formStageOptions.length - 2
              return !hideReview && index !== formStageOptions.length - 1 ? (
                <React.Fragment key={title}>
                  {index !== 0 && (
                    <div className={`${styles.divider} ${pos <= highestStepPos ? styles.success : ""}`} />
                  )}
                  <div
                    onClick={isAvailable ? () => updateStep(formStageOptions[pos]) : null}
                    className={`${styles.stage} ${pos == stepPos ? styles.active : ""} ${
                      isAvailable ? styles.available : ""
                    } ${isComplete ? styles.complete : ""}`}
                  >
                    <div className={styles.icon}>
                      {pos == stepPos && <img src={blueDots} alt="" />}
                      {((isAvailable && pos !== highestStepPos) || isComplete) && <img src={tickPink} alt="" />}
                    </div>
                    <span className={styles.label}>{title}</span>
                  </div>
                </React.Fragment>
              ) : null
            })}
          </div>
        </SiteWrapper>
      </div>
    </motion.div>
  )
}

export default FormHeader
